// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"7662d39a","170":"24962e44","413":"7953f8c0","883":"7762dfa6","885":"eddd8cf3"}[chunkId] + ".chunk.css";
};